import {
  TrashButton,
  ButtonsContainer,
  FamilyMemberName,
  FamilyMemberContainer,
  FamilyMemberPreviewContainer
} from './FamilyMember.styles';

import Button from '@CS/components/Button';
import EditIcon from '@/assets/images/icons/edit.svg?component';
import TrashIcon from '@/assets/images/icons/trash.svg?component';

type FamilyMemberProps = {
  onDelete: (name: string) => void;
  onEdit: (id: string) => void;
  backgroundColor: string;
  previewImage: string;
  name: string;
  id: string;
};

export const FamilyMember = ({
  backgroundColor,
  previewImage,
  onDelete,
  onEdit,
  id,
  name
}: FamilyMemberProps) => (
  <FamilyMemberContainer>
    <FamilyMemberPreviewContainer backgroundColor={backgroundColor}>
      <img alt={name} src={previewImage} />
    </FamilyMemberPreviewContainer>

    <FamilyMemberName>{name}</FamilyMemberName>

    <ButtonsContainer>
      <TrashButton onClick={onDelete.bind(null, id)} variant="icon">
        <TrashIcon />
      </TrashButton>

      <Button onClick={onEdit.bind(null, id)} variant="iconFill">
        <EditIcon />
      </Button>
    </ButtonsContainer>
  </FamilyMemberContainer>
);
